<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                allowClear
                placeholder="搜索关键字"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select
                v-model="queryParam.saiji"
                placeholder="请选择"
                allowClear
              >
                <a-select-option
                  v-for="(option, index) in saijiOptions"
                  :value="option.id"
                  >{{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
              <a-form-item label="缴费日期">
                <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                />
              </a-form-item>
          </a-col>
 
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? "收起" : "展开" }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"> 
      <a-button   icon="download" @click="saijiDownloads('saiquCaiwuHuizong')" >赛区财务汇总表</a-button> 
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="name" slot-scope="text, record">
        <div style="margin-left: 10px; float: left">
          {{ record.name }}
          <br /><span style="color: #999"
            >{{ record.province }}{{ record.city }}{{ record.county }}</span
          >
          <br />
          举办时间 {{ record.saidate | timeFormat }} 
        </div>
      </span>
      <span slot="status" slot-scope="text, record">
        应收 ￥102283.02  
        <br />
        已收 ￥102283.02 
        <br />
        未收 ￥102283.02 
        <br />
        应退款 ￥912.87
        <br />
        未退款 ￥512.00
        <br /> 
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleMingxi(record)">明细</a>
          <a-divider type="vertical" />    
          <a @click="saiquDownloads('saiquCaiwuLogDownload',record)">下载明细表</a>  

        </template>
      </span>
    </s-table>

    <a-modal
      :maskClosable="false"
      title="查看明细"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="mingxiVisible"
      @ok="mingxiVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
          :columns="mingxiColumns"
          :dataSource="mingxiList"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: 300 }"
          bordered
        >  
        </a-table>
      </a-spin>
    </a-modal>
   
  </a-card>
</template>

<script>
  import setting from '@/config/setting'
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import VideoUploader from "@/components/VideoUploader/";
import RSwitch from "@/components/RSwitch/";
import ContentPicker from "@/components/ContentPicker/";
import areaOptions from "@/utils/area";
import UserPicker from "@/components/UserPicker/";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

import {
  getSaiquList,  
  getSaijiList,
  getSubjectTypeOptions, 
  getCaiwuSaiquLogList,  
} from "@/api/sai";
import { deleteGuafen } from "@/api/guafen";

export default {
  name: "KaojiSaiquList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
    ContentPicker,
    UserPicker,
    VideoUploader,
  },
  data() {
    return {
      areaOptions,
      MiniCode: "",
      userListVisible:false,
      visible: false,
      applyVisible: false,
      documentVisible: false,
      saveLoading: false,
      subjectTypeOptions: [],
      mainUnitShow: false,
      holdUnitShow: false,
      helpUnitShow: false,
      unitName: "",
      holdUnitName: "",
      helpUnitName: "",
      time_range_moment:[], 
      saijiOptions: [],
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      }, 
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "汇总数据",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getSaiquList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [], 

      mingxiQuery: {
        saiqu: 0,
      },
      mingxiVisible: false,
      mingxiFormVisible: false,
      mingxiList: [],
      mingxiFormData: {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
        show_youer: 2,
        edit_admin: 2,
      },

      //表头
      mingxiColumns: [
        {
          title: "单位",
          dataIndex: "danwei", 
        },
        {
          title: "支付金额",
          width: "150px",
          dataIndex: "price", 
        }, 
        {
          title: "事由",
          width: "150px",
          dataIndex: "note",
        }, 
        {
          title: "时间",
          dataIndex: "create_time_str",
          width: "150px", 
        }, 
      ],
 
    };
  },
  computed: {},
  created() {},

  mounted() {
    let that = this;
    that.getSaijiOptions(); 
  },
  methods: {
    moment, 
    handleCancel() {
      this.visible = false;
    },
    getSaijiOptions() {
      let that = this;
      getSaijiList().then((res) => {
        that.saijiOptions = res.data.list;
      });
    }, 
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },      

    fetchMingxiList() {
      let self = this;
      getCaiwuSaiquLogList(self.mingxiQuery).then((res) => {
        self.mingxiList = res.data.list;
      });
    },

    handleMingxi(record) {
      let self = this;
      self.fetchMingxiList();
      self.mingxiQuery.saiqu = record.id;
      self.mingxiVisible = true;
    },
    
    saiquDownloads(type,record){
        window.open(setting.apiBaseURL+'/adminapi/sai/'+type+'?saiqu='+record.id);
    },
    saijiDownloads(type){
      if(this.time_range_moment.length==0){
          this.$message.error("请选择日期区间");
        return ;
      }
        window.open(setting.apiBaseURL+'/adminapi/sai/'+type+'?saiji='+this.queryParam.saiji);
    }, 
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
  },
  filters: {},
  watch: {},
};
</script>
<style scoped>
.MiniCode{
  margin: 0 auto;
}
</style>
